// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

// Local Storage wkeys
export const REMEMBERED_EMAIL_KEY = 'CNU_INVESTOR_EMAIL';
export const IDP_INFO_KEY = 'CNU_IDP_INFO';
